// Generated by purs version 0.13.8
"use strict";
var Data_Array = require("../Data.Array/index.js");
var Data_Lens_Iso = require("../Data.Lens.Iso/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var newtypeIso = function (dictNewtype) {
    return function (dictStrong) {
        return Data_Lens_Iso.iso(Data_Newtype.unwrap(dictNewtype))(Data_Newtype.wrap(dictNewtype))(dictStrong.Profunctor0());
    };
};
var listToArrayIso = function (dictProfunctor) {
    return Data_Lens_Iso.iso(Data_List.toUnfoldable(Data_Unfoldable.unfoldableArray))(Data_Array.toUnfoldable(Data_List_Types.unfoldableList))(dictProfunctor);
};
module.exports = {
    listToArrayIso: listToArrayIso,
    newtypeIso: newtypeIso
};
